<div *ngIf="ds.currentTournament.isTeamEvent" class="ui-g-12 team-title" translate>TOURNAMENTS.TEAMLIST</div>
<div *ngIf="!ds.currentTournament.isTeamEvent" class="ui-g-12 team-title" translate>TOURNAMENTS.PLAYERLIST</div>

<div *ngIf="!ds.mobile || !displayTeamInfo" class="ui-g-12 ui-lg-6">
    <p-table *ngIf="!ds.mobile" [value]="ds.currentTournament.teams" class="ui-g-12" [responsive]="false" [scrollable]="true" scrollHeight="calc(100vh - 20.1em)" scrollWidth="100%">
        <ng-template pTemplate="header">
            <tr>
                <th style="width: 2em;"></th>
                <th *ngIf="ds.currentTournament.isTeamEvent" translate>TOURNAMENTS.TEAMNAME</th>
                <th *ngIf="!ds.currentTournament.isTeamEvent" translate>TOURNAMENTS.PLAYERNAME</th>
                <th style="width: 5em;" translate>TOURNAMENTS.ACTIVE</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-t let-i="rowIndex">
            <tr (click)="onSelectTeam(t)">
                <td style="width: 2em;">{{ i + 1 }}</td>
                <td>{{ t.name }}</td>
                <td *ngIf="t.active" style=" width: 5em; text-align: center;"><i class="pi pi-check"></i></td>
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
            <tr>
                <td [attr.colspan]="2" style="border: 1px solid; border-color: #d9d9d9; padding: 5px">
                    {{ 'COMMON.NORECORDSFOUND' | translate }}
                </td>
            </tr>
        </ng-template>
    </p-table>

    <p-table *ngIf="ds.mobile" [value]="ds.currentTournament.teams" class="ui-g-12">
        <ng-template pTemplate="header">
            <tr>
                <th style="width: 2em;"></th>
                <th *ngIf="ds.currentTournament.isTeamEvent" translate>TOURNAMENTS.TEAMNAME</th>
                <th *ngIf="!ds.currentTournament.isTeamEvent" translate>TOURNAMENTS.PLAYERNAME</th>
                <th style="width: 5em;" translate>TOURNAMENTS.ACTIVE</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-t let-i="rowIndex">
            <tr (click)="onSelectTeam(t)">
                <td style="width: 2em;">{{ i + 1 }}</td>
                <td>{{ t.name }}</td>
                <td *ngIf="t.active" style=" width: 5em; text-align: center;"><i class="pi pi-check"></i></td>
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
            <tr>
                <td [attr.colspan]="2" style="border: 1px solid; border-color: #d9d9d9; padding: 5px">
                    {{ 'COMMON.NORECORDSFOUND' | translate }}
                </td>
            </tr>
        </ng-template>
    </p-table>
</div>

<div *ngIf="team.id && (displayTeamInfo || !ds.mobile)" class="ui-g-12 ui-lg-6">
    <div *ngIf="ds.mobile" class="ui-g-12" style="text-align: right;">
        <i class="pi pi-times" style="font-size: 1.2em; color: var(--text-color-secondary)" (click)="closeTeamInfo()"></i>
    </div>
    <div class="ui-g-3" style="text-align: right;">
        <span *ngIf="ds.currentTournament.isTeamEvent" class="team-label">{{ 'TOURNAMENTS.TEAM' | translate }}:</span>
        <span *ngIf="!ds.currentTournament.isTeamEvent" class="team-label">{{ 'TOURNAMENTS.PLAYER' | translate }}:</span>
    </div>
    <div class="ui-g-9" style="text-align: left;">
        <span class="team-value">{{ team.name }}</span>
    </div>
    <div *ngFor="let p of players; let i = index;" class="ui-g-12">
        <div class="ui-g-3" style="text-align: right;">
            <span *ngIf="i === 0" class="team-label">{{ 'TOURNAMENTS.PLAYERS' | translate }}:</span>
        </div>
        <div class="ui-g-9" style="text-align: left;">
            <span class="team-value">{{ p.firstName }}&nbsp;{{ p.lastName }}&nbsp;</span>
            <span *ngIf="p.city && p.city.length > 0" class="team-value">
                ({{ p.city }}
                <span *ngIf="p.state && p.state.length">,&nbsp;{{ p.state }}</span>)
            </span>
            <i *ngIf="p.captain" class="pi pi-flag team-value"></i>
        </div>
    </div>
</div>